
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';

export class QuotaWiseSubjectGradeStatisticsForm extends Form {
	private static _instance = new QuotaWiseSubjectGradeStatisticsForm();

	public static getInstance(): QuotaWiseSubjectGradeStatisticsForm {
		return QuotaWiseSubjectGradeStatisticsForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.opsAllowed = {get: true, filter: true};
	}

	public getName(): string {
		 return 'quotaWiseSubjectGradeStatistics';
	}
}


export class QuotaWiseSubjectGradeStatisticsFd extends FormData {
	constructor(form: QuotaWiseSubjectGradeStatisticsForm, sa: ServiceAgent) {
		super(form, sa);
	}
	/**  this form has no editable fields. data nust be accessed as Vo and not through fd **/
}


export interface QuotaWiseSubjectGradeStatisticsVo extends Vo {
	offeredSubjectId?: number, 
	seasonId?: number, 
	grade?: string, 
	instituteId?: number, 
	admissionQuota?: string, 
	nbr?: number
}
